const toPlainJson = (value)=>JSON.parse(JSON.stringify(value));
export const diffActivityLogs = (oldResult, newResult)=>{
    const oldPlain = toPlainJson(oldResult);
    const newPlain = toPlainJson(newResult);
    if (JSON.stringify(oldPlain) === JSON.stringify(newPlain)) {
        return null;
    }
    return {
        kind: 'mismatch',
        oldLength: oldResult.length,
        newLength: newResult.length
    };
};
export const buildDiffPayload = (args)=>({
        relationshipId: args.relationshipId,
        ffOpen: args.ffOpen,
        diff: args.diff,
        oldResult: args.oldResult,
        newResult: args.newResult,
        timestamp: args.timestamp
    });
